import React from 'react';
import { similarArticlesPropTypes } from './SimilarArticlesPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import ArticleTile from './components/ArticleTile/ArticleTile';
import * as styles from './SimilarArticles.module.scss';
const SimilarArticles = ({
  heading,
  items
}) => {
  if (!heading && !items) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), items && /*#__PURE__*/React.createElement("div", {
    className: styles.rootItems
  }, items.map((item, index) => /*#__PURE__*/React.createElement(ArticleTile, Object.assign({}, item, {
    isLarge: index < 3,
    key: index
  }))))));
};
export default SimilarArticles;